module.exports = __webpack_public_path__ + "static/media/restaurant_logo.c29516c2.svg";